/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function RoleInherit({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#RoleInherit_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M.9 2A1.6 1.6 0 0 1 2.5.4h2A1.6 1.6 0 0 1 6.1 2v.4h6.4A2.6 2.6 0 0 1 15.1 5v1a2.6 2.6 0 0 1-2.6 2.6h-1.97a2.6 2.6 0 0 1-5.06 0H3.5A1.4 1.4 0 0 0 2.1 10v1a1.4 1.4 0 0 0 1.4 1.4h6.4V12a1.6 1.6 0 0 1 1.6-1.6h2a1.6 1.6 0 0 1 1.6 1.6v2a1.6 1.6 0 0 1-1.6 1.6h-2A1.6 1.6 0 0 1 9.9 14v-.4H3.5A2.6 2.6 0 0 1 .9 11v-1a2.6 2.6 0 0 1 2.6-2.6h1.97a2.601 2.601 0 0 1 5.06 0h1.97A1.4 1.4 0 0 0 13.9 6V5a1.4 1.4 0 0 0-1.4-1.4H6.1V4a1.6 1.6 0 0 1-1.6 1.6h-2A1.6 1.6 0 0 1 .9 4zm4 0a.4.4 0 0 0-.4-.4h-2a.4.4 0 0 0-.4.4v2c0 .22.18.4.4.4h2a.4.4 0 0 0 .4-.4zm6.2 12v-2c0-.22.18-.4.4-.4h2c.22 0 .4.18.4.4v2a.4.4 0 0 1-.4.4h-2a.4.4 0 0 1-.4-.4M6.6 8a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0" clipRule="evenodd" /></g><defs><clipPath id="RoleInherit_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;